<template>
  <v-app :dark="isDark">
    <div id="app" :class="{ 'dark-mode': isDark }">
      <div class="bridge-unavailable" v-if="loading">
        Loading ⌛️
      </div>
      <div class="bridge-unavailable" v-else-if="!ok">
        Your browser not supported!
      </div>
      <v-container v-else>
        <v-calendar
            class="custom-calendar"
            is-expanded
            :attributes="calendarAttributes"
            :firstDayOfWeek=2
            @dayclick="selectDate"
            locale="ru"
        />
        <div :class="{ content: isDayStared }">
          <div :class="['body-common', isDayStared ? 'body-active' : 'body-inactive']">
            <p class="body-header">
              {{ isDayStared ? 'Рабочее время идет' + ': ' + timePassed : 'Начните рабочий день' }}
            </p>
            <div class="days-container">
              <div class="time-container">
                <p class="time-container-header time-container-time-text">Начало</p>
                <p :class="{'time-container-time': true, 'time-container-time-text': true, 'time-inactive': !isDayStared && !isDayEnded}">
                  {{ getTime(selectedDate, 'startTime') }}
                </p>
              </div>
              <div class="time-container">
                <p class="time-container-header time-container-time-text">Конец</p>
                <p :class="{'time-container-time': true, 'time-container-time-text': true, 'time-inactive': !isDayEnded}">
                  {{ getTime(selectedDate, 'endTime') }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="button-container" v-if="!isDayStared">
          <button @click="setStartTime" class="button">Начать</button>
        </div>
        <div v-else class="button-container">
          <button @click="showSheet = true" class="button button-active">Закончить</button>
        </div>

        <!-- Bottom Sheet -->
      <button class="reset-btn" @click="clearData">Reset</button>
      </v-container>
    </div>
      <v-bottom-sheet v-model="showSheet" inset attach="body">
        <v-card class="bottom-sheet-container" :class="{ 'dark-mode': isDark }">
          <div class="bottom-sheet-icon">
            <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.83333 48C4.36667 48 3.11111 47.4778 2.06667 46.4333C1.02222 45.3889 0.5 44.1333 0.5 42.6667V37.3333C0.5 36.5778 0.755556 35.9444 1.26667 35.4333C1.77778 34.9222 2.41111 34.6667 3.16667 34.6667C3.92222 34.6667 4.55556 34.9222 5.06667 35.4333C5.57778 35.9444 5.83333 36.5778 5.83333 37.3333V42.6667H43.1667V10.6667H5.83333V16C5.83333 16.7556 5.57778 17.3889 5.06667 17.9C4.55556 18.4111 3.92222 18.6667 3.16667 18.6667C2.41111 18.6667 1.77778 18.4111 1.26667 17.9C0.755556 17.3889 0.5 16.7556 0.5 16V5.33333C0.5 3.86667 1.02222 2.61111 2.06667 1.56667C3.11111 0.522222 4.36667 0 5.83333 0H43.1667C44.6333 0 45.8889 0.522222 46.9333 1.56667C47.9778 2.61111 48.5 3.86667 48.5 5.33333V42.6667C48.5 44.1333 47.9778 45.3889 46.9333 46.4333C45.8889 47.4778 44.6333 48 43.1667 48H5.83333ZM24.9667 29.3333H3.16667C2.41111 29.3333 1.77778 29.0778 1.26667 28.5667C0.755556 28.0556 0.5 27.4222 0.5 26.6667C0.5 25.9111 0.755556 25.2778 1.26667 24.7667C1.77778 24.2556 2.41111 24 3.16667 24H24.9667L21.3 20.2667C20.8111 19.7778 20.5556 19.1667 20.5333 18.4333C20.5111 17.7 20.7667 17.0667 21.3 16.5333C21.7889 16.0444 22.4111 15.8 23.1667 15.8C23.9222 15.8 24.5444 16.0444 25.0333 16.5333L33.3 24.8C33.8333 25.3333 34.1 25.9556 34.1 26.6667C34.1 27.3778 33.8333 28 33.3 28.5333L25.0333 36.8C24.5444 37.2889 23.9333 37.5444 23.2 37.5667C22.4667 37.5889 21.8333 37.3333 21.3 36.8C20.8111 36.3111 20.5667 35.6889 20.5667 34.9333C20.5667 34.1778 20.8111 33.5556 21.3 33.0667L24.9667 29.3333Z" fill="#BDC5CA"/>
            </svg>
          </div>
          <p class="bottom-sheet-title">Вы уверены что хотите завершить рабочий день?</p>
          <div class="buttons-wrapper">
            <div class="button-container">
              <button @click="setEndTime" class="button">Да завершить</button>
            </div>
            <div class="button-container">
              <button @click="showSheet = false" class="button cancel-button">Отмена</button>
            </div>
          </div>
        </v-card>
      </v-bottom-sheet>
  </v-app>
</template>

<script>
import {
  isWebViewBridgeAvailable,
  setTabActiveHandler,
  setTitle,
  backArrow,
  storage,
  onReady
} from '@orta/bridge';

export default {
  data() {
    return {
      loading: true,
      ok: false,
      isDayStared: false,
      isDayEnded: false,
      startTime: null,
      timePassed: "",
      timer: null,
      selectedDate: (() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      })(),
      timeRecords: {},
      showSheet: false,
      theme: "light",
    };
  },
  computed: {
    calendarAttributes() {
      const today = new Date();
      const todayLocal = today.getFullYear() + "-" +
          String(today.getMonth() + 1).padStart(2, "0") + "-" +
          String(today.getDate()).padStart(2, "0"); // YYYY-MM-DD

      return [
        ...Object.keys(this.timeRecords).map(date => ({
          key: date,
          highlight: {
            color: this.timeRecords[date].endTime ? "green" : "orange",
            fillMode: "light",
          },
          dates: [date]
        })),
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "solid"
          },
          dates: [todayLocal] // Use the local date instead of UTC
        },
        {
          key: "selected",
          highlight: {
            color: "red", // Highlight selected date in red
            fillMode: "solid"
          },
          dates: [this.selectedDate] // Ensure this is updated when a date is selected
        }
      ];
    },
    // formattedSelectedDate() {
    //   const [year, month, day] = this.selectedDate.split('-').map(Number);
    //   return new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(year, month - 1, day));
    // }
    isDark() {
      // return true
      return this.theme === "dark"; // Приводим к булевому значению
    },
  },
  methods: {
    async loadStoredData() {
      const storedData = await storage.getItem('timeTracker');
      if (storedData) {
        this.timeRecords = JSON.parse(storedData);
        if (this.timeRecords[this.selectedDate]?.startTime && !this.timeRecords[this.selectedDate]?.endTime) {
          this.isDayStared = true;
        }
        if (this.timeRecords[this.selectedDate]?.endTime) {
          this.isDayEnded = true;
        }
      }
    },
    async saveStoredData() {
      await storage.setItem('timeTracker', JSON.stringify(this.timeRecords));
    },
    tabActiveHandler() {
      this.$router.replace({
        name: 'HomeView'
      });
    },
    selectDate(day) {
      this.selectedDate = day.id;
    },
    setStartTime() {
      const today = new Date();
      const localToday = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
      if (this.selectedDate !== localToday) {
        alert("Вы можете начать рабочий день только для текущей даты.");
        return;
      }

      if (this.timeRecords[this.selectedDate]?.startTime && this.timeRecords[this.selectedDate]?.endTime) {
        alert("Этот рабочий день уже завершен, вы не можете его начать заново.");
        return;
      }

      const now = new Date().toISOString();
      this.isDayStared = true;

      this.$set(this.timeRecords, this.selectedDate, {
        startTime: now,
        endTime: this.timeRecords[this.selectedDate]?.endTime || null
      });
      if (this.ok) {
        this.saveStoredData();
      }
      this.updateTime();
      this.timer = setInterval(() => {
        if (this.isDayStared) {
          this.updateTime();
        } else {
          clearInterval(this.timer);
        }
      }, 60000);
    },
    setEndTime() {
      if (!this.timeRecords[this.selectedDate]) return;

      const now = new Date().toISOString();
      this.isDayStared = false;
      this.isDayEnded = true;
      this.timeRecords[this.selectedDate].endTime = now;
      if (this.ok) {
        this.saveStoredData();
      }
      this.showSheet = false;
    },
    getTime(date, key) {
      const timeString = this.timeRecords[date]?.[key];
      if (!timeString) return "--:--";

      const dateObj = new Date(timeString);
      const hours = String(dateObj.getHours()).padStart(2, "0");
      const minutes = String(dateObj.getMinutes()).padStart(2, "0");

      return `${hours}:${minutes}`;
    },
    async clearData() {
      try {
        await storage.clear()
      } catch (error) {
        alert(
            `${'Error while clearing data'}:
        ${JSON.stringify(error)}`
        )
      }
    },
    updateTime() {
      if (!this.isDayStared || !this.timeRecords[this.selectedDate]?.startTime) return;

      const now = new Date();
      const start = new Date(this.timeRecords[this.selectedDate].startTime); // Используем сохраненную дату

      const diff = now - start;
      if (diff < 0) {
        this.timePassed = "0 часов, 0 минут";
        return;
      }

      const diffMinutes = Math.floor(diff / (1000 * 60)) % 60;
      const diffHours = Math.floor(diff / (1000 * 60 * 60));

      this.timePassed = `${diffHours} часов, ${diffMinutes} минут`;
    }
  },
  mounted() {
    onReady(async() => {
      this.ok = isWebViewBridgeAvailable()
      this.loading = false
      await setTitle('Табель учета времени');
      await backArrow.setMode(true);
      await backArrow.setVisible(false);
      await setTabActiveHandler(this.tabActiveHandler.bind(this));
      await this.loadStoredData();
      if (this.isDayStared) {
        this.updateTime();
        this.timer = setInterval(this.updateTime, 60000);
      }      
    })
  },
  created() {
    this.theme = this.$route.query.theme || "light";
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>


<style>
#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: var(--bg-color);
}

:root {
  --bg-color: #ffffff;
  --bg-color-secondary: #F0F3F6;
  --text-color: #000000;
}

.dark-mode {
  --bg-color: #121212;
  --bg-color-secondary: #1B1B1B;
  --text-color: #ffffff;
}

.bridge-unavailable {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  height: 100vh; /* Full screen height */
}

.custom-calendar {
  background: var(--bg-color) !important;
  color: var(--text-color) !important;
}

.body-common {
  border-radius: 16px;
  padding: 12px 2px 4px;
  display: flex;
  flex-direction: column;
}

.body-header {
  color: #FFFFFF;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.content {
  flex: 1;
}

.body-inactive {
  background: linear-gradient(#113997, #ADC4FC);
}

.body-active {
  background: linear-gradient(#1EBC3B, #B0D8BF);
}

.days-container {
  display: flex;
  justify-content: space-between;
  margin: 12px 2px 2px;
  background: var(--bg-color);
  border-radius: 16px;
  padding: 12px;
  gap: 30px;
}

.time-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  padding: 7px 9px;
  background: var(--bg-color-secondary);
  border-radius: 12px;
}

.time-container-header {
    font-size: 10px;
}

.time-container-time {
  font-size: 18px;
  text-align: center;
}

.time-container-time-text {
  color: var(--text-color);
}

.time-inactive {
  opacity: 0.65;
}

.button-container {
  display: flex;
  margin-top: auto;
}

.button {
  flex: 1;
  background: #113997;
  margin: 0;
  border-radius: 12px;
  color: white;
  padding: 16px;
  font-weight: 600;
  font-size: 16px;
  font-family: 'Inter', sans-serif;
}

.button-active {
  background: var(--bg-color);
  color: #FF5757;
  border-style: solid;
  border-color: #FF5757;
}

.cancel-button {
  background: var(--bg-color-secondary);
  color: var(--text-color);
}

p {
  margin: 0 !important;
}

.bottom-sheet-container {
  padding-top: 56px;
  overflow: visible !important;
}

.buttons-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  padding: 12px 24px;
}

.bottom-sheet-icon {
  display: flex;
  justify-content: center;
  align-self: center;
}

.bottom-sheet-title {
  text-align: center;
  word-break: keep-all;
  font-weight: 600;
  font-size: 20px;
  padding: 24px;
  line-height: 120%;
  font-family: 'Inter', sans-serif;
  color: var(--text-color);
}

.reset-btn {
  //position: absolute;
  top: 0;
  left: 0;
}

.v-sheet.v-card {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background: var(--bg-color-secondary) !important;
}

.vc-title {
  color: var(--text-color) !important;
}

</style>
